module.exports = __webpack_public_path__ + "img/menu-icon-white.c2c388d4.svg";